// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1gfJB","title":"Info_title__2oK_4","selects":"Info_selects__VXRO7","requiredAsterisk":"Info_requiredAsterisk__1Xoyc"};